module.exports = __FOREMAN_VENDOR__LODASH__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__LODASH__"
// module id = lodash
// module chunks = 0